<template>
  <v-container fluid>
    <v-row>
      <v-col cols="5">
        <v-form class="mr-2" ref="workplaceInputForm" v-model="validForm">
          <v-row>
            <!--INPUT - PRVY STLPEC------------------------------------------------------------------------------->
            <v-col class="pt-0" cols="6">
              <v-combobox
                id="comboName"
                ref="comboName"
                v-model="document.name"
                :rules="[ruleRequired]"
                :label="$t('label.name') + ':'"
                height="25"
                maxlength="128"
                :items="listVisitors"
                item-text="comboBoxName"
                item-value="id"
                append-icon
                hide-details
                clearable
                :filter="ignoreAccent"
                v-on:change="processManualInput"
                autocomplete="off"
                :disabled="document.entryType === 'edoklady'"
              />
              <v-combobox
                ref="comboSurname"
                v-model="document.surname"
                :rules="[ruleRequired]"
                :label="$t('label.surname') + ':'"
                height="25"
                maxlength="128"
                :items="listVisitors"
                item-text="comboBoxName"
                item-value="id"
                append-icon
                hide-details
                clearable
                :filter="ignoreAccent"
                v-on:change="processManualInput"
                autocomplete="off"
                :disabled="document.entryType === 'edoklady'"
              />
              <v-combobox
                ref="comboDocumentno"
                v-model="document.documentno"
                :rules="[ruleRequired]"
                :label="$t('label.documentno') + ':'"
                height="25"
                maxlength="64"
                :items="listVisitors"
                item-text="comboBoxName"
                item-value="id"
                append-icon
                hide-details
                clearable
                :filter="ignoreAccent"
                v-on:change="processManualInput"
                autocomplete="off"
                :disabled="document.entryType === 'edoklady'"
              />
              <v-autocomplete
                ref="comboDocumenttype"
                v-model="document.documenttype"
                :rules="[ruleRequired]"
                :label="$tc('label.documentType') + ':'"
                height="25"
                maxlength="20"
                :items="listDocumentTypes"
                item-text="comboBoxName"
                item-value="type"
                auto-select-first
                append-icon
                hide-details
                clearable
                autocomplete="off"
                :disabled="document.entryType === 'edoklady'"
              />
              <v-menu
                v-if="$store.state.auth.wPlaceSettings.expire"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                :disabled="document.entryType === 'edoklady'"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="dateText"
                    v-model="dateFormatted"
                    :label="`${$t('label.expire')} (${$store.state.auth.df.date.replace('YYYY', $t('label.YYYY'))}):`"
                    v-bind:rules="$store.state.auth.wPlaceSettings.expireRequired ? [ruleRequired, ruleValidDate] : [ruleValidDate]"
                    :append-icon="mdiCalendar"
                    @blur="document.expire = momentParse(dateFormatted)"
                    height="25"
                    hide-details
                    v-on="on"
                    autocomplete="off"
                    :disabled="document.entryType === 'edoklady'"
                  />
                </template>
                <v-date-picker
                  :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
                  v-model="document.expire"
                  no-title
                  @input="dateMenu = false"
                />
              </v-menu>
              <v-autocomplete
                v-if="$store.state.auth.wPlaceSettings.country"
                v-bind:rules="$store.state.auth.wPlaceSettings.countryRequired ? [ruleRequired] : []"
                ref="comboCountry"
                v-model="document.country"
                :label="$tc('label.country') + ':'"
                height="25"
                maxlength="50"
                :items="listCountries"
                item-text="comboBoxName"
                item-value="A3"
                append-icon
                auto-select-first
                hide-details
                clearable
                autocomplete="off"
                :disabled="document.entryType === 'edoklady'"
              />
              <v-combobox
                v-if="$store.state.auth.wPlaceSettings.cards && !$store.state.auth.wPlaceSettings.cardsList"
                ref="comboVisitorCard"
                v-model="document.visitorcard"
                :label="$tc('label.visitorcard') + ':'"
                :rules="
                  !outButton && $store.state.auth.wPlaceSettings.cardsRequired && document.documenttypeCategory != 'PRC'
                    ? [ruleRequired]
                    : []
                "
                :items="listCards"
                item-text="identifier"
                item-value="identifier"
                height="25"
                maxlength="64"
                append-icon
                hide-details
                clearable
                autocomplete="off"
              />
              <v-autocomplete
                v-if="$store.state.auth.wPlaceSettings.cards && $store.state.auth.wPlaceSettings.cardsList"
                ref="comboVisitorCard"
                v-model="document.visitorcard"
                :label="$tc('label.visitorcard') + ':'"
                :rules="
                  !outButton && $store.state.auth.wPlaceSettings.cardsRequired && document.documenttypeCategory != 'PRC'
                    ? [ruleRequired]
                    : []
                "
                :items="listCards"
                item-text="identifier"
                item-value="identifier"
                height="25"
                maxlength="64"
                v-on:click="listCardsLoad"
                v-on:change="searchByCard"
                :return-object="true"
                auto-select-first
                append-icon
                hide-details
                hide-no-data
                clearable
                autocomplete="off"
              />
              <v-combobox
                v-if="$store.state.auth.wPlaceSettings.employee"
                ref="comboEmployee"
                v-model="document.employee"
                :label="$t('label.visiting') + ':'"
                v-bind:rules="$store.state.auth.wPlaceSettings.employeeRequired && !outButton ? [ruleRequired] : []"
                height="25"
                maxlength="128"
                :items="listEmployees"
                item-text="comboBoxName"
                item-value="id"
                v-on:change="checkEmployeeObject"
                v-bind:append-icon="employeeEditIcon()"
                @click:append="openEmployeeEdit"
                hide-details
                clearable
                autocomplete="off"
              />
            </v-col>
            <!--INPUT - DRUHY STLPEC------------------------------------------------------------------------------->
            <v-col class="pt-0" cols="6">
              <v-combobox
                v-if="$store.state.auth.wPlaceSettings.company"
                ref="comboCompany"
                v-model="document.company"
                :label="$tc('label.company') + ':'"
                v-bind:rules="$store.state.auth.wPlaceSettings.companyRequired && !outButton ? [ruleRequired] : []"
                height="25"
                maxlength="128"
                :items="listCompanies"
                item-text="name"
                item-value="id"
                v-bind:append-icon="$store.state.auth.wPlaceSettings.companyList ? mdiPlusCircle : ''"
                @click:append="openCompanyEdit"
                v-on:change="checkCompanyObject"
                hide-details
                clearable
                autocomplete="off"
              />

              <v-combobox
                v-if="$store.state.auth.wPlaceSettings.cars"
                ref="comboCar"
                v-model="document.car"
                :label="$tc('label.car') + ':'"
                v-bind:rules="$store.state.auth.wPlaceSettings.carsRequired && !outButton ? [ruleRequired] : []"
                height="25"
                maxlength="16"
                :items="listCars"
                item-text="plate"
                item-value="id"
                v-bind:append-icon="$store.state.auth.wPlaceSettings.carsList ? mdiPlusCircle : ''"
                @click:append="openCarEdit"
                hide-details
                clearable
                v-on:change="checkCarObject"
                autocomplete="off"
              />
              <v-select
                v-if="showAreas"
                ref="comboArea"
                v-model="document.area"
                :label="$tc('label.area') + ':'"
                height="25"
                :items="listAreas"
                :return-object="true"
                append-icon
                item-text="name"
                item-value="id"
                hide-details
                autocomplete="off"
                :disabled="document.iwpMandatory > 0"
              />
              <v-select
                v-if="document.area.medicalCertificate"
                ref="selectMedicalCertificate"
                v-model="document.medicalCertificate"
                :rules="[ruleRequired]"
                :label="$t('label.medicalCertificate') + ':'"
                height="25"
                :items="listMedicalCertificates"
                item-text="text"
                item-value="value"
                append-icon
                hide-details
                autocomplete="off"
              />
              <v-text-field
                ref="usrDef1text"
                v-if="$store.state.auth.settings.usrDef1name && $store.state.auth.wPlaceSettings.usrDef1"
                :label="$store.state.auth.settings.usrDef1name"
                v-model="document.usrDef1"
                v-bind:rules="$store.state.auth.wPlaceSettings.usrDef1Required ? [ruleRequired] : []"
                height="25"
                maxlength="128"
                hide-details
                clearable
              />
              <v-text-field
                ref="usrDef2text"
                v-if="$store.state.auth.settings.usrDef2name && $store.state.auth.wPlaceSettings.usrDef2"
                :label="$store.state.auth.settings.usrDef2name"
                v-model="document.usrDef2"
                v-bind:rules="$store.state.auth.wPlaceSettings.usrDef2Required ? [ruleRequired] : []"
                height="25"
                maxlength="128"
                hide-details
                clearable
              />
              <v-text-field
                ref="usrDef3text"
                v-if="$store.state.auth.settings.usrDef3name && $store.state.auth.wPlaceSettings.usrDef3"
                :label="$store.state.auth.settings.usrDef3name"
                v-model="document.usrDef3"
                v-bind:rules="$store.state.auth.wPlaceSettings.usrDef3Required ? [ruleRequired] : []"
                height="25"
                maxlength="128"
                hide-details
                clearable
              />
              <v-text-field
                ref="usrDef4text"
                v-if="$store.state.auth.settings.usrDef4name && $store.state.auth.wPlaceSettings.usrDef4"
                :label="$store.state.auth.settings.usrDef4name"
                v-model="document.usrDef4"
                v-bind:rules="$store.state.auth.wPlaceSettings.usrDef4Required ? [ruleRequired] : []"
                height="25"
                maxlength="128"
                hide-details
                clearable
              />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <!--TLACITKA------------------------------------------------------------------------------->
      <v-col cols="3">
        <v-row>
          <v-col class="py-1">
            <v-row class="pa-3">
              <v-col class="pa-0" :cols="$store.state.auth.wPlaceSettings.edType && $store.state.auth.settings.edoklady ? 8 : 12">
                <v-btn
                  v-if="!outButton"
                  v-bind:disabled="!$store.state.websocket.isConnected"
                  style="height: 74px"
                  block
                  class="display-1"
                  color="colorEnter"
                  @click="checkVisitorNotify"
                >
                  {{ $t('btn.enter') }}
                </v-btn>

                <v-btn
                  v-else
                  :disabled="document.signStatus == 1 || document.signStatus == 3"
                  style="height: 74px"
                  block
                  class="display-1"
                  color="colorExit"
                  @click="((document.updateType = 'tranExit'), saveTransaction())"
                >
                  {{ $t('btn.exit') }}
                </v-btn>
              </v-col>
              <v-col
                v-if="$store.state.auth.wPlaceSettings.edType && $store.state.auth.settings.edoklady"
                class="pa-0 d-flex justify-center"
                cols="4"
              >
                <v-btn @click="dialogReadEdoklad = true" style="height: 74px; width: 74px" text rounded>
                  <img height="74" src="@/assets/eDoklady.png" />
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1" cols="6">
            <v-btn @click="$store.commit('currentDocument', {})" color="colorDelete" block>{{ $t('btn.clear') }}</v-btn>
          </v-col>
          <v-col class="py-1" cols="6">
            <v-btn @click="getReport" color="colorReport" :disabled="!outButton || document.area.report == 0" block>
              <v-icon class="mr-4">{{ mdiPrinter }}</v-icon>
              {{ $t('btn.ticket') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1" cols="6">
            <v-btn :disabled="!outButton" @click="((document.updateType = 'tranUpdate'), saveTransaction())" color="colorEdit" block>
              {{ $t('btn.edit') }}
            </v-btn>
          </v-col>
          <v-col class="py-1" cols="6">
            <v-btn @click="getReportTransactions" color="colorReport" :disabled="$store.state.auth.wPlaceSettings.report == 0" block>
              <v-icon class="mr-2">{{ mdiPrinter }}</v-icon>
              {{ $t('btn.list') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1" cols="6">
            <v-btn
              v-if="$store.state.auth.userInterfaceSettings.showAllTransactions"
              block
              color="colorFilterTrue"
              @click="showAllTransactions"
            >
              {{ $t('btn.allVisits') }} ({{ currentViewTranCount }})
            </v-btn>
            <v-btn v-else block color="colorFilterFalse" @click="showAllTransactions"
              >{{ $t('btn.presentVisits') }} ({{ currentViewTranCount }})</v-btn
            >
          </v-col>
          <v-col class="py-1" cols="6">
            <v-tooltip
              v-if="$store.state.auth.wPlaceSettings.edType === 'printer' && $store.state.auth.settings.edoklady"
              bottom
              :open-delay="500"
            >
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="dialogEdokladyNewQR = true" :color="edokladyBtnStyle()" block>
                  <v-icon class="mr-4">{{ mdiPrinter }}</v-icon>
                  ED QR &nbsp;
                </v-btn>
              </template>
              <span>
                {{ $t('label.edoklady') }} - {{ $t('label.expire') }}: {{ momentFormat($store.state.auth.wPlaceSettings.edQRValidTo) }}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pl-2 pt-1 pb-0">
            <h3>
              <div v-if="$store.state.websocket.newtemperature.tempBody">
                <v-icon>{{ mdiThermometer }}</v-icon>
                <span :class="temperatureColor()">{{ $store.state.websocket.newtemperature.tempBody }} </span>
              </div>
              <v-spacer v-else style="height: 28px" />
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              :label="$t('label.visitorNote') + ':'"
              v-model="document.note"
              height="25"
              maxlength="128"
              hide-details
              clearable
            />
            <v-text-field
              :label="$t('label.visitorNotify') + ':'"
              v-model="document.notify"
              height="25"
              maxlength="128"
              hide-details
              clearable
            />
          </v-col>
        </v-row>
      </v-col>
      <!--WIDGETY------------------------------------------------------------------------------->
      <v-col class="pa-1" cols="4">
        <v-tabs grow v-model="activeWidget" background-color="colorComponentsBackground" height="30">
          <v-tab>{{ $t('label.detail') }}</v-tab>
          <v-tab v-if="$store.state.auth.settings.planVisits">{{ $t('label.visitsPlan') }}</v-tab>
        </v-tabs>
        <v-tabs-items eager v-model="activeWidget">
          <v-tab-item>
            <v-sheet color="colorComponentsBackground">
              <WidgetAdditionalInfo
                v-bind:employee="$store.state.auth.wPlaceSettings.employeeList ? document.employee : {}"
                v-bind:car="$store.state.auth.wPlaceSettings.carsList ? document.car : {}"
                v-bind:company="$store.state.auth.wPlaceSettings.companyList ? document.company : {}"
              />
            </v-sheet>
          </v-tab-item>
          <v-tab-item eager v-if="$store.state.auth.settings.planVisits">
            <v-sheet color="colorComponentsBackground">
              <WidgetPlannedVisits
                :openPlanned.sync="openPlanedVisits"
                :searchPlannedVisit="document"
                :documentTypes="listDocumentTypes"
                :countries="listCountries"
              />
            </v-sheet>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <!--MODALY------------------------------------------------------------------------------->
    <v-dialog v-model="modalVisitorNotify" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineWarning" primary-title>{{ $t('head.visitorWarning') }}</v-card-title>
        <v-card-text>
          <v-sheet class="mt-3" height="120">
            <v-row>
              <v-col>
                <h1>{{ document.notify }}</h1>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-col cols="6">
            <v-btn block color="colorExit" @click="($store.commit('currentDocument', {}), (modalVisitorNotify = false))">
              {{ $t('btn.enterCancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block color="colorEnter" @click="(checkExpiredDocument(), (modalVisitorNotify = false))">
              {{ $t('btn.enterConfirm') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalExpiredDocument" persistent max-width="60%">
      <v-card height="50%">
        <v-card-title class="headline colorHeadlineWarning" primary-title>{{ $t('head.documentExpired') }}</v-card-title>
        <v-card-text>
          <v-sheet class="mt-3" height="120">
            <v-row>
              <v-col>
                <h1>{{ $t('msg.documentExpired') }}!</h1>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-col cols="6">
            <v-btn block color="colorExit" @click="($store.commit('currentDocument', {}), (modalExpiredDocument = false))">
              {{ $t('btn.enterCancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block color="colorEnter" @click="(checkInvalidDocument(), (modalExpiredDocument = false))">
              {{ $t('btn.enterConfirm') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalInvalidDocument" persistent max-width="60%">
      <v-card height="50%">
        <v-card-title class="headline colorHeadlineWarning" primary-title>{{ $t('head.documentInvalid') }}</v-card-title>
        <v-card-text>
          <v-sheet class="mt-3" height="120">
            <v-row>
              <v-col>
                <h1>{{ $t('msg.documentInvalid') }}!</h1>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-col cols="6">
            <v-btn block color="colorExit" @click="($store.commit('currentDocument', {}), (modalInvalidDocument = false))">
              {{ $t('btn.enterCancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block color="colorEnter" @click="(checkItems(), (modalInvalidDocument = false))">{{ $t('btn.enterConfirm') }}</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalCheckingDocument" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline" primary-title>{{ $t('head.checkingDocument') }}</v-card-title>
        <div style="min-height: 300px" class="text-md-center">
          <div style="min-height: 80px" />
          <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalItemsNotify" persistent max-width="60%">
      <v-card height="50%">
        <v-card-title class="headline colorHeadlineWarning" primary-title>{{ $t('head.itemsInspection') }}</v-card-title>
        <v-card-text>
          <v-sheet class="mt-3" height="120">
            <v-row>
              <v-col>
                <h1>{{ $t('msg.itemsInspection') }}:</h1>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h1>{{ itemsNotify }}</h1>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-col cols="6">
            <v-btn block color="colorExit" @click="($store.commit('currentDocument', {}), (modalItemsNotify = false))">
              {{ $t('btn.enterCancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block color="colorEnter" @click="(saveTransaction(), (modalItemsNotify = false))">{{ $t('btn.enterConfirm') }}</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalPrintLoader" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $t('head.printProgress') }}</v-card-title>
        <div style="min-height: 300px" class="text-md-center">
          <div style="min-height: 80px" />
          <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalCardInUseNotify" persistent max-width="40vw">
      <v-card>
        <v-card-title class="headline colorHeadlineWarning">{{ $t('msg.cardAllocated') }}</v-card-title>
        <v-card-text>
          <h2>{{ cardInUseNotifyCache.name }} {{ cardInUseNotifyCache.surname }}</h2>
          <h2>{{ cardInUseNotifyCache.documenttype }} {{ cardInUseNotifyCache.documentno }}</h2>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn block color="colorClose" @click="((document.visitorcard = ''), (modalCardInUseNotify = false))">{{
            $t('btn.close')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalEmployeeEdit" persistent max-width="60%">
      <EmployeeEdit
        :selectedEmployee="document.employee"
        v-on:closeDialog="modalEmployeeEdit = false"
        v-on:newEmployeeID="listEmployeesLoad"
      />
    </v-dialog>

    <v-dialog v-model="modalCompanyEdit" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $tc('label.company') }}</v-card-title>
        <v-card-text>
          <v-text-field :label="$t('label.companyName')" v-model="companyEdit.name" maxlength="128" required></v-text-field>
          <v-text-field :label="$t('label.vatNumber')" maxlength="32" v-model="companyEdit.vatin"></v-text-field>
          <v-text-field :label="$t('label.address')" maxlength="256" v-model="companyEdit.address"></v-text-field>
          <v-textarea
            :label="$t('label.note')"
            v-model="companyEdit.note"
            name="input-7-1"
            maxlength="512"
            hide-details
            dense
            no-resize
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn block color="colorEnter" @click="((document.company = { ...companyEdit }), (modalCompanyEdit = false))">
            {{ $t('btn.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalCarEdit" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $tc('label.car') }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field :label="$t('label.carPlate')" v-model="carEdit.plate" maxlength="64" required />
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :label="$tc('label.country')"
                v-model="carEdit.state"
                :items="listCountries"
                item-text="comboBoxName"
                item-value="A3"
                cache-items
                append-icon
                hide-details
                clearable
              />
            </v-col>
          </v-row>
          <v-text-field :label="$t('label.carType')" maxlength="64" v-model="carEdit.type" />
          <v-text-field :label="$t('label.carColor')" maxlength="64" v-model="carEdit.color" />
          <v-textarea :label="$t('label.note')" v-model="carEdit.note" maxlength="512" name="input-7-1" hide-details dense no-resize />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn block color="colorEnter" @click="((document.car = { ...carEdit }), (modalCarEdit = false))">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogEdoklady :openDialog.sync="dialogReadEdoklad" />
    <DialogConfirm
      :openDialog.sync="dialogEdokladyNewQR"
      v-on:confirm="getEdokladyQR"
      :header="$t('label.qrEdokladyGenerate')"
      :body="$t('msg.qrEdokladyWarning')"
    />
    <DialogInfo :openDialog.sync="dialogInfo.open" :header="dialogInfo.header" :body="dialogInfo.body" />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import WidgetAdditionalInfo from '@/components/WorkplaceWidgetInfo.vue';
import WidgetPlannedVisits from '@/components/WorkplaceWidgetPlanedVisits.vue';
import EmployeeEdit from '@/components/dataEdit/employee.vue';
import DialogInfo from '@/components/DialogInfo.vue';
import DialogEdoklady from '@/components//DialogEdoklady.vue';
import DialogConfirm from './DialogConfirm.vue';

import { mdiCalendar, mdiPen, mdiPrinter, mdiPlusCircle, mdiThermometer } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsItems',
  components: {
    WidgetAdditionalInfo,
    WidgetPlannedVisits,
    EmployeeEdit,
    DialogInfo,
    DialogConfirm,
    DialogEdoklady,
  },
  data: () => ({
    dialogInfo: {
      header: '',
      body: '',
      open: false,
    },
    dialogReadEdoklad: false,
    dialogEdokladyNewQR: false,
    tempBody: '',
    document: {
      id: 0,
      uuid: '',
      country: '',
      documentno: '',
      documenttype: '',
      documenttypeCategory: '', // Kategorie dokumentu 'VIC'-navstevni, 'PRC'-premanentni, ''-akakolvek ina
      expire: '',
      name: '',
      surname: '',
      visitorID: 0,
      tranFrom: '', // reader (ctecka), input (form), log (aktualne transakce click)
      entryType: '', // reader, manual - kontrola zmeny zosnimanych dat
      updateType: '',
      timeenter: '' as any, // Povol null koli exportu do reportov
      timeexit: '' as any, // Povol null koli exportu do reportov
      visitorCount: 0, // poradove cislo navstevy za dany den a vratnicu
      note: '',
      notify: '',
      signStatus: 0,
      area: {
        id: 0,
        name: '',
        controlleditems: [],
        report: 0,
        medicalCertificate: false,
      },
      employee: {
        id: 0,
        orgID: '',
        name: '',
        surname: '',
        comboBoxName: '', // Vyskladane meno pre combo
        comboBoxID: '', // Pracovne ID pre combo
        department: '',
        position: '',
        note: '',
        email: '',
        phone: '',
      },
      car: {
        id: 0,
        plate: '',
        state: '',
        color: '',
        type: '',
        note: '',
      },
      company: {
        id: 0,
        name: '',
        vatin: '',
        address: '',
        note: '',
      },
      visitorcard: {
        id: 0,
        identifier: '',
        code: '',
        note: '',
      } as any,
      usrDef1: '',
      usrDef2: '',
      usrDef3: '',
      usrDef4: '',
      clientID: '',
      medicalCertificate: 'unproven',
      timezone: '',
      iwpMandatory: 0,
      parent: null,
    },
    readerTran: {
      // orig. transakcia ze ctecky
      country: '',
      documentno: '',
      documenttype: '',
      expire: '',
      name: '',
      surname: '',
    },
    outButton: false,
    validForm: false,
    showAreas: false,
    listMedicalCertificates: [
      { text: 'Neprokázaný', value: 'unproven' },
      { text: 'Očkovací certifikát', value: 'vaccinationCertificate' },
      { text: 'Očkovací certifikát (ověřený)', value: 'vaccinationCertificateVerified', disabled: true },
      { text: 'PCR Test', value: 'PCRTest' },
      { text: 'Ag Test', value: 'AgTest' },
      { text: 'Digitální zelený certifikát', value: 'unproven' },
    ],
    listVisitors: [{}],
    listDocumentTypes: [{ type: '', category: '' }],
    listDocumentTypesOther: [{ type: '', category: '' }],
    listCountries: [{}],
    listCards: [{}],
    listEmployees: [
      {
        id: 0,
        orgID: '',
        name: '',
        surname: '',
        comboBoxName: '', // Vyskladane meno pre combo
        comboBoxID: '', // Pracovne ID pre combo
        department: '',
        position: '',
        note: '',
        email: '',
        phone: '',
      },
    ],
    listAreas: [
      {
        id: 0,
        name: '',
        controlleditems: [],
        report: 0,
        medicalCertificate: false,
      },
    ],
    listCompanies: [
      {
        id: 0,
        name: '',
        vatin: '',
        address: '',
        note: '',
      },
    ],
    listCars: [
      {
        id: 0,
        plate: '',
        state: '',
        color: '',
        type: '',
        note: '',
      },
    ],
    dateFormatted: '',
    dateMenu: false,
    cardInUseNotifyCache: { name: '', surname: '', documenttype: '', documentno: '' },
    modalCardInUseNotify: false,
    modalEmployeeEdit: false,
    companyEdit: {
      id: 0,
      name: '',
      vatin: '',
      address: '',
      note: '',
    },
    modalCompanyEdit: false,
    carEdit: {
      id: 0,
      plate: '',
      state: '',
      color: '',
      type: '',
      note: '',
    },
    modalCarEdit: false,
    modalVisitorNotify: false,
    modalExpiredDocument: false,
    modalCheckingDocument: false,
    modalInvalidDocument: false,
    itemsNotify: '',
    modalItemsNotify: false,
    modalPrintLoader: false,
    currentViewTranCount: 0,
    activeWidget: 0,
    openPlanedVisits: false,
    mdiCalendar: mdiCalendar,
    mdiPen: mdiPen,
    mdiPlusCircle: mdiPlusCircle,
    mdiPrinter: mdiPrinter,
    mdiThermometer: mdiThermometer,
  }),
  watch: {
    '$store.state.websocket.newtemperature.tempBody'() {
      if (this.$store.state.websocket.newtemperature.tempBody !== '') {
        if (parseFloat(this.$store.state.websocket.newtemperature.tempBody) > parseFloat(this.$store.state.auth.settings.temperature)) {
          this.dialogInfo.header = 'Kontrola teploty';
          this.dialogInfo.body = `Zjištena zvýšená teplota: ${this.$store.state.websocket.newtemperature.tempBody} C`;
          this.dialogInfo.open = true;
        }
      }
    },
    '$store.state.websocket.newqrcode.type'() {
      //TODO - priprava na vakcinacne QR kody
      if (this.$store.state.websocket.newqrcode.type === 'vaccination' && this.document.name !== '') {
        const qrName = this.$store.state.websocket.newqrcode.name
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase();
        const qrSurame = this.$store.state.websocket.newqrcode.surname
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase();
        const qrDocumentno = this.$store.state.websocket.newqrcode.documentno.toUpperCase();
        const qrPassportNo = this.$store.state.websocket.newqrcode.passportno.toUpperCase();
        const docName = this.document.name.toUpperCase();
        const docSurname = this.document.surname.toUpperCase();
        const docDocumentno = this.document.documentno.toUpperCase();
        if (qrName === docName && qrSurame === docSurname && (qrDocumentno === docDocumentno || qrPassportNo === docDocumentno)) {
          if (this.document.area.medicalCertificate) {
            this.document.medicalCertificate = 'vaccinationCertificateVerified';
          } else {
            this.dialogInfo.header = 'Kontrola očkovacího certifikátu';
            this.dialogInfo.body = 'Zvolený prostor nevyžaduje očkovací certifikát';
            this.dialogInfo.open = true;
          }
        } else {
          this.dialogInfo.header = 'Kontrola očkovacího certifikátu';
          this.dialogInfo.body = 'NEPLATNÝ CERTIFIKÁT!';
          this.dialogInfo.open = true;
        }
      }
      this.$store.commit('newqrcode', { type: '' });
    },
    '$store.state.websocket.transactions'() {
      this.countCurrentView();
    },
    // Prijatie dat ako "current" - ze ctecky, alebo klikom na transakciu
    '$store.state.websocket.currentDocument'() {
      const data = JSON.parse(JSON.stringify(this.$store.state.websocket.currentDocument));
      for (const docType of this.listDocumentTypesOther) {
        if (docType.type === data.documenttype && docType.category === 'VIC') {
          this.$set(this.document, 'visitorcard', { id: 0, identifier: '', code: '', note: '' }); // pridaj reaktivny objekt
          this.document.visitorcard.identifier = data.documentno;
          this.searchByCard(this.document.visitorcard);
          return;
        }
      }
      this.cleanForm().then(() => {
        this.document = { ...this.document, ...data };
        this.processCurrentDocument();
        const form: any = this.$refs.workplaceInputForm;
        form.validate();
      });
    },
    'document.expire'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.document.expire).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateFormatted = date;
        } else {
          // this.$store.commit('globalMessage', 'Špatně zadaný datum expirace !!!');
          this.document.expire = '';
          this.dateFormatted = '';
        }
      });
    },
    activeWidget() {
      this.$store.commit('activeWidget', this.activeWidget);
      axios
        .patch('/api/v1/user/settings', this.$store.state.auth.userInterfaceSettings)
        .then(() => {
          // console.log(response.data);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    'document.documenttype'() {
      // Ak je typ PRC(permanentna navsteva) nevyzaduje sa navstevna karta
      let docType: { type: string; category: string };
      for (docType of this.listDocumentTypes) {
        if (docType.type === this.document.documenttype) {
          this.document.documenttypeCategory = docType.category;
        }
      }
    },
  },
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleValidDate() {
      return (v: any) =>
        v == '' || this.$moment(v, this.$store.state.auth.df.date, true).isValid() || this.$i18n.t('msg.invalidDateFormat');
    },
  },
  mounted() {
    if (this.$store.state.clientID === '') {
      this.$router.push('/norights');
      return;
    }
    this.countCurrentView();
    this.listVisitorsLoad();
    this.listDocumentTypesLoad();
    this.listCountriesLoad();
    this.listAreasLoad();
    this.activeWidget = this.$store.state.auth.userInterfaceSettings.activeWidget;
    if (this.$store.state.auth.wPlaceSettings.cardsList) {
      this.listCardsLoad();
    } else {
      this.listCards = [];
    }
    if (this.$store.state.auth.wPlaceSettings.employeeList) {
      this.listEmployeesLoad(0);
    } else {
      this.listEmployees = [];
    }
    if (this.$store.state.auth.wPlaceSettings.companyList) {
      this.listCompaniesLoad();
    } else {
      this.listCompanies = [];
    }
    if (this.$store.state.auth.wPlaceSettings.carsList) {
      this.listCarsLoad();
    } else {
      this.listCars = [];
    }
    this.$nextTick(() => {
      this.cleanForm().then(() => {
        if (this.$store.state.auth.wPlaceSettings.areas.length > 1) {
          this.showAreas = true;
        }
      });
    });
  },
  methods: {
    processCurrentDocument() {
      switch (this.document.tranFrom) {
        case 'reader': {
          // console.log('tranZ_reader', this.document);
          this.readerTran = { ...this.document };
          this.pairVisitor();
          break;
        }
        case 'input': {
          // console.log('tranZ_input');
          this.appendVisitorData();
          break;
        }
        case 'log': {
          // console.log('tranZ_LOG');
          this.logTranProcessing();
          this.updateAreaReport();
          this.personInObject();
          break;
        }
        case 'inObject': {
          // console.log('tranZ_inObject');
          let area: any;
          for (area of this.listAreas) {
            if (area.id === this.document.area.id) {
              this.document.area = { ...area };
              break;
            }
          }
          if (this.document.entryType === 'reader') {
            this.readerTran = { ...this.document };
          }
          this.updateAreaReport();
          this.outButton = true;
          this.logTranProcessing();
          break;
        }
        case 'planedVisit': {
          // console.log('tranZ_plan', this.document);
          this.readerTran = { ...this.document };
          this.pairVisitor();
          break;
        }
        case '': {
          // console.log('tranZ_prazdnyCase', this.document.tranFrom);
          if (this.document.name === '') {
            // Vycisteny form
            return;
          }
          break;
        }
        default: {
          // console.log('Z NEZNAMA', this.document.tranFrom);
        }
      }
    },
    pairVisitor() {
      // sparuj ak navsteva uz je zaevidovana
      const getDefaults: any = this.$options;
      let visitor = { ...getDefaults.data().document };
      let visitorFound = false;
      for (visitor of this.listVisitors) {
        if (visitor.documentno === this.document.documentno && visitor.documenttype === this.document.documenttype) {
          // Dopln data z tabulky visitors len ak niesu z transakcie
          if (this.document.tranFrom !== 'log') {
            // Ak je chyba v citani dopln z Visitors inak ponechaj nacitane
            if (this.document.name.includes('*')) {
              this.document.name = visitor.name;
            }
            if (this.document.surname.includes('*')) {
              this.document.surname = visitor.surname;
            }
            if (this.document.expire !== null && this.document.expire.includes('*')) {
              this.document.expire = visitor.expire;
            }
            if (this.document.country.includes('*')) {
              this.document.country = visitor.country;
            }
            this.document.notify = visitor.notify;
            if (this.document.tranFrom !== 'planedVisit') {
              this.document.note = visitor.note;
              this.document.employee = { ...getDefaults.data().document.employee };
              this.document.car = { ...getDefaults.data().document.car };
              this.document.company = { ...getDefaults.data().document.company };
              this.document.employee = { ...visitor.employee };
              this.document.car = { ...visitor.car };
              this.document.company = { ...visitor.company };
            }
          }
          this.appendVisitorData();
          visitorFound = true;
          break;
        }
      }
      // Ak ide o novu navstevu tak sa nekontroluje "personInObject()" a teda sa musi volat popup aj tu
      this.$store.state.auth.wPlaceSettings.plannedVisitsPopup && this.document.tranFrom == 'reader' && !visitorFound
        ? (this.openPlanedVisits = true)
        : null;
      // Ak je v PlannedVisit tak doplnit data aj ked este nebol evidovany ako navsteva
      if (this.document.tranFrom === 'planedVisit') {
        this.appendVisitorData();
      }
    },
    personInObject() {
      // Check if person is already in object
      for (const transaction of this.$store.state.websocket.transactions) {
        if (
          transaction.documentno === this.document.documentno &&
          transaction.documenttype === this.document.documenttype &&
          transaction.timeexit === ''
        ) {
          let current = { ...transaction }; // transakce zo storu sa nesmie menit mimo mutace
          current.tranFrom = 'inObject';
          this.$store.commit('currentDocument', { ...current });
          this.outButton = true;
          return;
        }
      }
      this.outButton = false;
      // Ak osoba neni v objekte a ma sa zobrazovat okno s naplanovanymi navstevami tak ho zobraz
      this.$store.state.auth.wPlaceSettings.plannedVisitsPopup && this.document.tranFrom == 'reader'
        ? (this.openPlanedVisits = true)
        : null;
    },
    processManualInput(value: any) {
      // On change na Combo dopln data
      // Pri mazani formu values neexistuju takze vyskoc
      if (value === null) {
        if (this.document.name === null) {
          this.document.name = '';
        }
        if (this.document.surname === null) {
          this.document.surname = '';
        }
        if (this.document.documentno === null) {
          this.document.documentno = '';
        }
        return;
      }
      // Pri mazani Xkom values undefined takze vyskoc
      if (value === undefined) {
        if (this.outButton) {
          this.cleanForm();
          this.$store.commit('currentDocument', {});
        }
        return;
      }
      // Ak je hodnota zadana rucne vrati sa string a teda neprepisuj
      if (typeof value === 'string') {
        return;
      }
      value.tranFrom = 'input';
      this.$store.commit('currentDocument', { ...value });
    },
    appendVisitorData() {
      if (!this.$store.state.auth.wPlaceSettings.prefillEmployee && this.document.tranFrom != 'planedVisit') {
        this.document.employee.id = 0;
      }
      if (!this.$store.state.auth.wPlaceSettings.prefillCompany && this.document.tranFrom != 'planedVisit') {
        this.document.company.id = 0;
      }
      if (!this.$store.state.auth.wPlaceSettings.prefillCar && this.document.tranFrom != 'planedVisit') {
        this.document.car.id = 0;
      }
      // V planovanej navsteve je potrebne doplnit detaily area
      if (this.document.tranFrom === 'planedVisit') {
        for (const area of this.listAreas) {
          if (area.id === this.document.area.id) {
            this.document.area = area;
            break;
          }
        }
      }
      // TODO: Ak bude poziadavka pridat na parameter vo workplaces predplnanie userDef
      this.document.usrDef1 = '';
      this.document.usrDef2 = '';
      this.document.usrDef3 = '';
      this.document.usrDef4 = '';
      // Dopln detaily k zamestnancovi
      if (this.document.employee.id === 0 || !this.$store.state.auth.wPlaceSettings.employeeList) {
        delete this.document.employee;
      } else {
        for (const employee of this.listEmployees) {
          if (employee.id === this.document.employee.id) {
            this.document.employee = employee;
            break;
          }
        }
      }
      // dopln detaily k firme
      if (this.document.company === undefined || this.document.company.id === 0 || !this.$store.state.auth.wPlaceSettings.companyList) {
        delete this.document.company;
      } else {
        for (const company of this.listCompanies) {
          if (company.id === this.document.company.id) {
            this.document.company = company;
            break;
          }
        }
      }
      // dopln detaily k vozidlu
      if (this.document.car === undefined || this.document.car.id === 0 || !this.$store.state.auth.wPlaceSettings.carsList) {
        delete this.document.car;
      } else {
        for (const car of this.listCars) {
          if (car.id === this.document.car.id) {
            this.document.car = car;
            break;
          }
        }
      }
      this.personInObject();
    },
    listDocumentTypesLoad() {
      this.listDocumentTypes = [];
      (this.listDocumentTypesOther = []),
        axios
          .get('/api/v1/documenttype')
          .then((response) => {
            for (const docType of response.data) {
              docType.comboBoxName = docType.type + ' - ' + docType.name;
              if (docType.category === '' || docType.category === 'PRC') {
                this.listDocumentTypes.push(docType);
              } else {
                this.listDocumentTypesOther.push(docType);
              }
            }
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
    },
    listCountriesLoad() {
      this.listCountries = [];
      axios
        .get('/api/v1/countries')
        .then((response) => {
          for (const country of response.data) {
            country.comboBoxName = country.A3 + ' - ' + country.czShort;
          }
          this.listCountries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listCardsLoad() {
      this.listCards = [];
      axios
        .get('/api/v1/cardbyworkplace')
        .then((response) => {
          this.listCards = response.data;
          // Pokial je v tran karta ktora neexistuje v zozname (ak niektora vratnica umoznuje manualne zadavanie)
          for (const row of this.$store.state.websocket.transactions) {
            if (row.timeexit === '' && row.visitorcard.identifier !== '') {
              this.listCards.push(row.visitorcard); // Duplicity si vyriesi comboBox
            }
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listVisitorsLoad() {
      this.listVisitors = [];
      axios
        .get('/api/v1/visitor')
        .then((response) => {
          for (const visitor of response.data) {
            visitor.comboBoxName = visitor.name + ' ' + visitor.surname + ', ' + visitor.documenttype + ', ' + visitor.documentno;
          }
          this.listVisitors = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listEmployeesLoad(newEmployeeID: number) {
      axios
        .get('/api/v1/employeebyworkplace')
        .then((response) => {
          for (const employee of response.data) {
            employee.comboBoxName = employee.surname + ' ' + employee.name;
            if (employee.department != '') {
              employee.comboBoxName = employee.comboBoxName + ' (' + employee.department + ')';
            }
            employee.id === newEmployeeID ? (this.document.employee = employee) : '';
          }
          this.listEmployees = response.data;
          //this.document.employee.id = newEmployeeID;
          this.modalEmployeeEdit = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listAreasLoad() {
      this.listAreas = [];
      axios
        .get('/api/v1/area')
        .then((response) => {
          for (const areaIncluded of this.$store.state.auth.wPlaceSettings.areas) {
            for (const area of response.data) {
              if (areaIncluded === area.id) {
                this.listAreas.push(area); // Napln listbox podla povolenych objektov
              }
              if (area.id === this.$store.state.auth.wPlaceSettings.defaultarea) {
                this.document.area = area; // Prednastav vychozi objekt
              }
            }
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    updateAreaReport() {
      let area: any;
      for (area of this.listAreas) {
        if (area.id === this.document.area.id) {
          this.document.area.report = area.report;
          return;
        }
      }
    },
    listCompaniesLoad() {
      axios
        .get('/api/v1/company')
        .then((response) => {
          this.listCompanies = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listCarsLoad() {
      axios
        .get('/api/v1/car')
        .then((response) => {
          this.listCars = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    searchByCard(value: any) {
      if (value === undefined) {
        const getDefaults: any = this.$options;
        this.document.visitorcard = { ...getDefaults.data().document.visitorcard };
      } else {
        for (const row of this.$store.state.websocket.transactions) {
          if (row.visitorcard.identifier === value.identifier && row.timeexit === '') {
            this.cardInUseNotifyCache = row;
            if (
              this.document.timeenter === '' &&
              (this.document.name !== '' || this.document.surname !== '' || this.document.documentno !== '')
            ) {
              this.modalCardInUseNotify = true;
            } else {
              this.$store.commit('currentDocument', { ...row });
            }
            return;
          }
        }
      }
    },
    checkVisitorCardObject() {
      // Ak je rucne zadane skonvertuje na objekt
      if (this.document.visitorcard === null) {
        // Ak bol zmazany Xkom tak nahrad prazdnym
        delete this.document.visitorcard;
        return;
      }
      if (typeof this.document.visitorcard === 'string') {
        const visitorcardIdentifier = this.document.visitorcard;
        const getDefaults: any = this.$options;
        this.document.visitorcard = { ...getDefaults.data().document.visitorcard };
        this.document.visitorcard.identifier = visitorcardIdentifier;
      }
    },
    checkEmployeeObject() {
      // Ak je rucne zadane skonvertuje na objekt
      if (this.document.employee === null) {
        // Ak bol zmazany Xkom tak nahrad prazdnym
        delete this.document.employee;
      }
      if (typeof this.document.employee === 'string' && this.document.employee !== '') {
        // pre istotu skontroluj ci nejde o Zamestnanca zo zoznamu
        for (const employee of this.listEmployees) {
          if (this.document.employee === employee.name) {
            this.document.employee = { ...employee };
            return;
          }
        }
        const employeeName = this.document.employee;
        const getDefaults: any = this.$options;
        this.document.employee = { ...getDefaults.data().document.employee };
        this.document.employee.name = employeeName;
        this.document.employee.comboBoxName = employeeName;
      }
    },
    checkCompanyObject() {
      // Ak je rucne zadane skonvertuje na objekt
      if (this.document.company === null) {
        // Ak bol zmazany Xkom tak nahrad prazdnym
        delete this.document.company;
      }
      if (typeof this.document.company === 'string') {
        if (this.document.company !== '') {
          // pre istotu skontroluj ci nejde o auto zo zoznamu
          for (const company of this.listCompanies) {
            if (company.name === this.document.company) {
              this.document.company = { ...company };
              return;
            }
          }
        }
        // Inak skonvertuj na objekt
        const companyName = this.document.company;
        const getDefaults: any = this.$options;
        this.document.company = { ...getDefaults.data().document.company };
        this.document.company.name = companyName;
      }
    },
    checkCarObject() {
      // Ak je rucne zadane skonvertuje na objekt
      if (this.document.car === null) {
        // Ak bol zmazany Xkom tak nahrad prazdnym
        delete this.document.car;
      }
      if (typeof this.document.car === 'string') {
        if (this.document.car !== '') {
          // pre istotu skontroluj ci nejde o auto zo zoznamu
          for (const car of this.listCars) {
            if (this.document.car === car.plate) {
              this.document.car = { ...car };
              return;
            }
          }
        }
        // Inak skonvertuj na objekt
        const carPlate = this.document.car;
        const getDefaults: any = this.$options;
        this.document.car = { ...getDefaults.data().document.car };
        this.document.car.plate = carPlate;
      }
    },
    logTranProcessing() {
      if (this.document.employee.id === 0 && this.document.employee.name === '') {
        delete this.document.employee;
      } else {
        this.document.employee.comboBoxName = this.document.employee.name + ' ' + this.document.employee.surname;
      }
      if (this.document.car.id === 0 && this.document.car.plate === '') {
        delete this.document.car;
      }
      if (this.document.company.id === 0 && this.document.company.name === '') {
        delete this.document.company;
      }
      if (this.document.visitorcard.id === 0 && this.document.visitorcard.identifier === '') {
        delete this.document.visitorcard;
      }
    },
    openEmployeeEdit() {
      const refs: any = this.$refs; // Vopicarna pre validny TS
      refs.comboEmployee.blur();
      this.modalEmployeeEdit = true;
    },
    openCompanyEdit() {
      const refs: any = this.$refs; // Vopicarna pre validny TS
      if (typeof this.document.company === 'object') {
        this.companyEdit = { ...this.document.company };
        this.companyEdit.name = refs.comboCompany.lazySearch;
      } else {
        this.companyEdit.name = refs.comboCompany.lazySearch;
      }
      this.modalCompanyEdit = true;
    },
    openCarEdit() {
      const refs: any = this.$refs; // Vopicarna pre validny TS
      if (typeof this.document.car === 'object') {
        this.carEdit = { ...this.document.car };
        this.carEdit.plate = refs.comboCar.lazySearch;
      } else {
        this.carEdit.plate = refs.comboCar.lazySearch;
      }
      this.modalCarEdit = true;
    },
    checkTransactionChanges() {
      // v pripade manualnych zmien v nacitanych udajov vrat true
      if (this.document.entryType == 'edoklady') {
        return;
      }
      if (
        this.readerTran.country === this.document.country &&
        this.readerTran.documentno === this.document.documentno &&
        this.readerTran.documenttype === this.document.documenttype &&
        this.readerTran.expire === this.document.expire &&
        this.readerTran.name === this.document.name &&
        this.readerTran.surname === this.document.surname
      ) {
        this.document.entryType = 'reader';
      } else {
        this.document.entryType = 'manual';
      }
    },
    checkBlur() {
      return new Promise((resolve) => {
        const refs: any = this.$refs; // Vopicarna pre validny TS
        refs.comboName.blur();
        refs.comboSurname.blur();
        refs.comboDocumentno.blur();
        refs.comboDocumenttype.blur();
        if (this.document.area.medicalCertificate) {
          refs.selectMedicalCertificate.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.expire) {
          refs.dateText.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.country) {
          refs.comboCountry.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.cards) {
          refs.comboVisitorCard.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.employee) {
          refs.comboEmployee.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.company) {
          refs.comboCompany.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.cars) {
          refs.comboCar.blur();
        }
        if (this.showAreas) {
          refs.comboArea.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.usrDef1) {
          refs.usrDef1text.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.usrDef2) {
          refs.usrDef2text.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.usrDef4) {
          refs.usrDef3text.blur();
        }
        if (this.$store.state.auth.wPlaceSettings.usrDef4) {
          refs.usrDef4text.blur();
        }
        resolve(true);
      });
    },
    cleanForm() {
      return new Promise((resolve) => {
        this.checkBlur().then(() => {
          const defaults: any = this.$options;
          this.document = { ...defaults.data().document };
          this.companyEdit = { ...defaults.data().companyEdit };
          this.carEdit = { ...defaults.data().carEdit };
          delete this.document.employee;
          delete this.document.company;
          delete this.document.car;
          delete this.document.visitorcard;
          const form: any = this.$refs;
          form.workplaceInputForm.validate();
          // TODO dopriesit focus na meno
          // form.comboName.focus();
          this.$store.commit('newtemperature', { tempBody: '' });
          this.outButton = false;
          let area: any;
          for (area of this.listAreas) {
            if (area.id === this.$store.state.auth.wPlaceSettings.defaultarea) {
              this.document.area = area; // Prednastav vychozi objekt
            }
          }
        });
        resolve(true);
      });
    },
    getReport() {
      this.modalPrintLoader = true;
      setTimeout(() => {
        this.modalPrintLoader = false;
      }, 4500);
      // Prazdne casy nahrad null koli GO unmrshall
      let formatedData = { ...this.document };
      // formatedData.visitorCount = this.$store.getters.transactions.length + 1;
      if (formatedData.timeenter === '') {
        formatedData.timeenter = null;
      }
      if (formatedData.timeexit === '') {
        formatedData.timeexit = null;
      }
      axios
        .post(`/api/v1/report/visitorcard/${this.document.area.report}`, formatedData)
        .then((response) => {
          if (this.$store.state.appMode === 'electron') {
            const link = document.createElement('a');
            link.href = `/api/v1/report/${response.data.uuid}/pdf`;
            link.setAttribute('download', 'listek.pdf');
            document.body.appendChild(link);
            link.click();
          } else {
            let printWin = window.open(
              `/api/v1/report/${response.data.uuid}/pdf`,
              'portunus-print-window',
              'location=no,titlebar=no,toolbar=no,status=no,menubar=no,width=1024,height=900',
            );
            /*
            printWin.document.write(
              "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + response.data + "'></iframe>",
            );
            */
            if (printWin === null) {
              this.modalPrintLoader = false;
              alert(this.$i18n.t('msg.popupRequired'));
              return;
            }
            printWin!.addEventListener(
              'load',
              () => {
                printWin!.focus();
                printWin!.print();
              },
              false,
            );
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    getEdokladyQR() {
      this.modalPrintLoader = true;
      setTimeout(() => {
        this.modalPrintLoader = false;
      }, 4500);
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      axios
        .get(`/api/v1/edoklady/print`, { params: { timezone: timezone } })
        .then((response) => {
          let printWin = window.open(
            `/api/v1/report/${response.data.uuid}/pdf`,
            'portunus-print-window',
            'location=no,titlebar=no,toolbar=no,status=no,menubar=no,width=1024,height=900',
          );
          if (printWin === null) {
            this.modalPrintLoader = false;
            alert(this.$i18n.t('msg.popupRequired'));
            return;
          }
          printWin!.addEventListener(
            'load',
            () => {
              printWin!.focus();
              printWin!.print();
            },
            false,
          );
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    getReportTransactions() {
      this.modalPrintLoader = true;
      setTimeout(() => {
        this.modalPrintLoader = false;
      }, 4500);
      var reportData = [];
      // presypat data do report data aby sa neprepisovali vazbou data v store
      for (const row of this.$store.state.websocket.transactions) {
        var mRow = { ...row }; //row sa nesmie modifikovat mimo storeCommit
        if (mRow.timeexit === '') {
          mRow.timeexit = null;
          reportData.push({ ...mRow });
        } else {
          if (this.$store.state.auth.userInterfaceSettings.showAllTransactions) {
            reportData.push({ ...mRow });
          }
        }
      }
      switch (this.$store.state.transactionsTableOptions.sortBy[0]) {
        case 'timeenter':
          if (this.$store.state.transactionsTableOptions.sortDesc[0]) {
            reportData.sort((a, b) => (a.timeenter < b.timeenter ? 1 : -1));
          } else {
            reportData.sort((a, b) => (a.timeenter > b.timeenter ? 1 : -1));
          }
          break;
        case 'timeexit':
          if (this.$store.state.transactionsTableOptions.sortDesc[0]) {
            reportData.sort((a, b) => (a.timeenter > b.timeenter ? 1 : -1));
            reportData.sort((a, b) => ((a.timeexit !== null ? a.timeexit : '0') < (b.timeexit !== null ? b.timeexit : '0') ? 1 : -1));
            // reportData.sort((a, b) => ((a.timeexit !== null ? a.timeexit : '0') < (b.timeexit !== null ? b.timeexit : '0')) ? 1 : ((a.timeexit !== null ? a.timeexit : '0') === (a.timeexit !== null ? a.timeexit : '0')) ? ((a.timeenter > b.timeenter) ? 1 : -1) : -1)
            // reportData.sort((a, b) => ((a.timeexit !== null ? a.timeexit : -1) > (b.timeexit !== null ? b.timeexit : -1)) ? 1 : ((a.timeenter !== null ? a.timeenter : -1) === (a.timeenter !== null ? a.timeenter : -1)) ? ((a.timeexit > b.timeexit) ? 1 : -1) : -1)
          } else {
            reportData.sort((a, b) => (a.timeenter < b.timeenter ? 1 : -1));
            reportData.sort((a, b) => ((a.timeexit !== null ? a.timeexit : '0') > (b.timeexit !== null ? b.timeexit : '0') ? 1 : -1));
            // reportData.sort((a, b) => ((a.timeexit !== null ? a.timeexit : '0') > (b.timeexit !== null ? b.timeexit : '0')) ? 1 : ((a.timeexit !== null ? a.timeexit : '0') === (a.timeexit !== null ? a.timeexit : '0')) ? ((a.timeenter > b.timeenter) ? 1 : -1) : -1)
            // reportData.sort((a, b) => ((a.timeexit !== null ? a.timeexit : -1) < (b.timeexit !== null ? b.timeexit : -1)) ? 1 : ((a.timeenter !== null ? a.timeenter : -1) === (a.timeenter !== null ? a.timeenter : -1)) ? ((a.timeexit > b.timeexit) ? 1 : -1) : -1)
          }
          break;
        case 'name':
        case 'surname':
        case 'workplaceNameEnter':
          if (this.$store.state.transactionsTableOptions.sortDesc[0]) {
            reportData.sort((a, b) =>
              a[this.$store.state.transactionsTableOptions.sortBy[0]].toLowerCase() <
              b[this.$store.state.transactionsTableOptions.sortBy[0]].toLowerCase()
                ? 1
                : -1,
            );
          } else {
            reportData.sort((a, b) =>
              a[this.$store.state.transactionsTableOptions.sortBy[0]].toLowerCase() >
              b[this.$store.state.transactionsTableOptions.sortBy[0]].toLowerCase()
                ? 1
                : -1,
            );
          }
          break;
        case 'area.name':
          if (this.$store.state.transactionsTableOptions.sortDesc[0]) {
            reportData.sort((a, b) => (a['area']['name'].toLowerCase() < b['area']['name'].toLowerCase() ? 1 : -1));
          } else {
            reportData.sort((a, b) => (a['area']['name'].toLowerCase() > b['area']['name'].toLowerCase() ? 1 : -1));
          }
          break;
        default:
          reportData.sort((a, b) => (a.timeexit > b.timeexit ? 1 : a.timeexit === b.timeexit ? (a.timeenter < b.timeenter ? 1 : -1) : -1));
      }
      axios
        .post(`/api/v1/report/transactions/${this.$store.state.auth.wPlaceSettings.report}`, reportData)
        .then((response) => {
          if (this.$store.state.appMode === 'electron') {
            const link = document.createElement('a');
            link.href = `/api/v1/report/${response.data.uuid}/pdf`;
            link.setAttribute('download', 'seznam.pdf');
            document.body.appendChild(link);
            link.click();
          } else {
            let printWin = window.open(
              `/api/v1/report/${response.data.uuid}/pdf`,
              'portunus-print-window',
              'location=no,titlebar=no,toolbar=no,status=no,menubar=no,width=1024,height=900',
            );
            /*
            printWin.document.write(
              "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + response.data + "'></iframe>",
            );
            */
            if (printWin === null) {
              this.modalPrintLoader = false;
              alert(this.$i18n.t('msg.popupRequired'));
              return;
            }
            printWin!.addEventListener(
              'load',
              () => {
                printWin!.focus();
                printWin!.print();
              },
              false,
            );
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    countCurrentView() {
      // Spocitaj pocet zaznamov podla aktualneho filtra
      this.currentViewTranCount = 0;
      if (!this.$store.state.auth.userInterfaceSettings.showAllTransactions) {
        for (const tran of this.$store.state.websocket.transactions) {
          if (tran.timeexit === '' && tran.parent === null) {
            this.currentViewTranCount++;
          }
        }
      } else {
        for (const tran of this.$store.state.websocket.transactions) {
          if (tran.parent === null) {
            this.currentViewTranCount++;
          }
        }
      }
    },
    showAllTransactions() {
      this.cleanForm();
      if (this.$store.state.auth.userInterfaceSettings.showAllTransactions) {
        this.$store.commit('showAllTransactions', false);
      } else {
        this.$store.commit('showAllTransactions', true);
      }
      this.countCurrentView();
      axios
        .patch('/api/v1/user/settings', this.$store.state.auth.userInterfaceSettings)
        .then(() => {
          // console.log(response.data);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    checkVisitorNotify() {
      if (this.document.notify !== '' && this.$store.state.websocket.currentDocument.tranFrom !== 'inObject') {
        this.modalVisitorNotify = true;
      } else {
        this.checkExpiredDocument();
      }
    },
    checkExpiredDocument() {
      const expireDate = new Date(this.document.expire);
      const currentDate = new Date();
      if (expireDate < currentDate) {
        this.modalExpiredDocument = true;
      } else {
        this.checkInvalidDocument();
      }
    },
    async checkInvalidDocument() {
      // kontrola kradnuteho dokladu
      if (this.document.country !== '' && this.$store.state.auth.settings.checkDocumentValidity) {
        this.modalCheckingDocument = true;
        await axios
          .get(`/api/v1/documentcheck/${this.document.country}/${this.document.documenttype}/${this.document.documentno}`, {
            timeout: 1000 * 30,
          })
          .then((response) => {
            this.modalCheckingDocument = false;
            if (response.data.invalid) {
              this.modalInvalidDocument = true;
            } else {
              this.checkItems();
            }
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
      } else {
        this.checkItems();
      }
    },
    checkItems() {
      // Kontrola predmetov: Null: objekt nema predmety , Undefined: objekt je z aktualnych transakcii
      if (this.document.area.controlleditems === null || this.document.area.controlleditems === undefined) {
        this.saveTransaction();
      } else {
        this.itemsNotify = '';
        axios
          .get('/api/v1/item')
          .then((response) => {
            for (const controlleditem of this.document.area.controlleditems) {
              for (const item of response.data) {
                if (controlleditem === item.id) {
                  this.itemsNotify = this.itemsNotify + ', ' + item.item;
                }
              }
            }
            this.itemsNotify = this.itemsNotify.substr(1);
            this.modalItemsNotify = true;
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
      }
    },
    saveTransaction() {
      // Casy musia byt null pre GO parser, cas prichodu sa uklada podla servru
      this.document.timeenter = null;
      this.document.timeexit = null;
      if (typeof Intl.DateTimeFormat().resolvedOptions().timeZone == 'undefined') {
        this.$store.commit('globalMessage', 'INVALID TIME ZONE INFO!');
        return;
      }
      this.document.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // this.document.clientID = this.$store.state.clientID; // zmena-prebera sa zo session
      if (!this.document.area.medicalCertificate) {
        this.document.medicalCertificate = '';
      }
      this.checkBlur()
        .then(async () => {
          this.checkTransactionChanges();
          this.checkEmployeeObject();
          this.checkCarObject();
          this.checkCompanyObject();
          this.checkVisitorCardObject();
        })
        .then(async () => {
          const form: any = this.$refs.workplaceInputForm;
          if (!form.validate()) {
            this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
          } else {
            // Ak sa maju ukladat firmy a firma nebola zo zoznamu a je zadane tak uloz
            if (this.$store.state.auth.settings.autoSaveCompanies && this.$store.state.auth.wPlaceSettings.companyList) {
              if (typeof this.document.company !== 'undefined') {
                await axios
                  .post('/api/v1/company', this.document.company)
                  .then((response) => {
                    // Ak je existujuca firma (-1) alebo prazdna firma (0)
                    if (response.data.newCompanyID === -1) {
                      axios.put('/api/v1/company', this.document.company).catch((err) => {
                        this.$store.dispatch('catchErrHandler', err);
                      });
                    }
                    if (response.data.newCompanyID > 0) {
                      this.document.company.id = response.data.newCompanyID; // Ak sa zalozi nova firma updatni ID
                      this.listCompaniesLoad();
                    }
                  })
                  .catch((err) => {
                    this.$store.dispatch('catchErrHandler', err);
                  });
              }
            }
            // Ak sa maju ukladat vozidla a vozidlo nebolo zo zoznamu a je zadane tak uloz
            if (this.$store.state.auth.settings.autoSaveCars && this.$store.state.auth.wPlaceSettings.carsList) {
              if (typeof this.document.car !== 'undefined') {
                await axios
                  .post('/api/v1/car', this.document.car)
                  .then((response) => {
                    // Ak je existujuca SPZ (-1) alebo prazdna SPZ (0)
                    if (response.data.newCarID === -1) {
                      axios.put('/api/v1/car', this.document.car).catch((err) => {
                        this.$store.dispatch('catchErrHandler', err);
                      });
                    }
                    if (response.data.newCarID > 0) {
                      this.document.car.id = response.data.newCarID; // Ak sa zalozi nove vozidlo updatni ID
                      this.listCarsLoad();
                    }
                  })
                  .catch((err) => {
                    this.$store.dispatch('catchErrHandler', err);
                  });
              }
            }

            // Ak navsteva neexistuje a ma sa ukladat tak sa prida
            if (this.$store.state.auth.settings.autoSaveVisitors) {
              await axios
                .post('/api/v1/visitor', this.document)
                .then((response) => {
                  this.document.visitorID = response.data.visitor;
                  this.listVisitorsLoad();
                })
                .catch((err) => {
                  this.$store.dispatch('catchErrHandler', err);
                });
            }

            // Ak je nastaveny prichod, tak zaeviduj prichod, ak odchod tak ochod
            if (!this.outButton) {
              // Spocita poradove cislo navstevy za dany den
              const today = new Date();
              let todayCounter: number = 1;
              for (const tran of this.$store.state.websocket.transactions) {
                const tranDate = new Date(tran.timeenter);
                if (tranDate.getMonth() === today.getMonth() && tranDate.getDate() === today.getDate()) {
                  todayCounter++;
                }
              }
              this.document.visitorCount = todayCounter;
              if (this.$store.state.auth.wPlaceSettings.printGuestTicket && !this.outButton && this.document.area.report !== 0) {
                this.getReport();
              }
              axios
                .post('/api/v1/transaction', this.document)
                .then(() => {
                  this.cleanForm();
                })
                .catch((err) => {
                  this.$store.dispatch('catchErrHandler', err);
                });
            } else {
              // Ak je povinna vnorena vratnica skontroluj prichod a odchod
              if (this.document.iwpMandatory > 0) {
                const child = this.$store.state.websocket.transactions.find((t: any) => this.document.uuid === t.parent);
                // Ak je povinny prichod a nema prichod
                if (child === undefined && this.document.iwpMandatory < 3) {
                  this.$store.commit('globalMessage', this.$i18n.t('tt.areaRequireRegistrationEnter'));
                  return;
                }
                // Ak je povinny prichod a nema odchod
                if (this.document.iwpMandatory === 2 && (child.timeexit === '' || child.timeexit === null)) {
                  this.$store.commit('globalMessage', this.$i18n.t('tt.areaRequireRegistrationExit'));
                  return;
                }
                // Require exit only if child exists
                if (this.document.iwpMandatory === 3 && child !== undefined && (child.timeexit === '' || child.timeexit === null)) {
                  this.$store.commit('globalMessage', this.$i18n.t('tt.areaRequireRegistrationExit'));
                  return;
                }
              }
              // this.document.updateType = 'tranExit';
              axios
                .put('/api/v1/transaction', this.document)
                .then(() => {
                  this.cleanForm();
                  this.listVisitorsLoad();
                })
                .catch((err) => {
                  this.$store.dispatch('catchErrHandler', err);
                });
            }
          }
        });
    },
    employeeEditIcon() {
      if (this.$store.state.auth.wPlaceSettings.employeeList) {
        if (this.$store.state.auth.userSettings.accEmployees.write && (!this.document.employee || this.document.employee.id === 0)) {
          return mdiPlusCircle;
        }
        if (
          (this.$store.state.auth.userSettings.accEmployees.write || this.$store.state.auth.userSettings.accEmployees.update) &&
          this.document.employee
        ) {
          return mdiPen;
        }
      }
      return '';
    },
    temperatureColor() {
      if (parseFloat(this.$store.state.websocket.newtemperature.tempBody) <= parseFloat(this.$store.state.auth.settings.temperature)) {
        return 'green--text';
      }
      return 'red--text';
    },
    ignoreAccent(item: any, queryText: any) {
      return (
        item.comboBoxName
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .indexOf(
            queryText
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          ) > -1
      );
    },
    momentParse(inputDate: string) {
      return this.$moment(inputDate, this.$store.state.auth.df.date, true).isValid()
        ? this.$moment(inputDate, this.$store.state.auth.df.date).format('YYYY-MM-DD')
        : '';
    },
    momentFormat(inputDate: string) {
      return this.$moment(inputDate).isValid() ? this.$moment(inputDate, 'YYYY-MM-DD').format(this.$store.state.auth.df.date) : '';
    },
    edokladyBtnStyle() {
      const daysToExpire = this.$moment(this.$store.state.auth.wPlaceSettings.edQRValidTo, null).diff(this.$moment(), 'days');
      if (daysToExpire < 3) {
        return 'colorDelete';
      } else if (daysToExpire < 7) {
        return 'colorCancel';
      } else {
        return 'colorReport';
      }
    },
  },
});
</script>
